import { Col, Row } from "reactstrap";
import AppSpinner from "../../../elements/AppSpinner";

const LocationSuggestions = ({
  suggestions,
  loading,
  getSuggestionItemProps,
}) => {
  return (
    <>
      {suggestions.length > 0 && (
        <div>
          {loading && <AppSpinner size="sm" />}

          {suggestions.map((suggestion, index) => {
            const style = suggestion.active
              ? { backgroundColor: "#e9f7ed", cursor: "pointer" }
              : { backgroundColor: "#ffffff", cursor: "pointer" };
            return (
              <div
                className={`p-2 ${
                  index !== suggestions?.length - 1 &&
                  "border-bottom border-superlight"
                }`}
                {...getSuggestionItemProps(suggestion, { style })}
                key={suggestion?.placeId}
              >
                <Row className="align-items-center" key={index}>
                  <Col xs="auto">
                    <i
                      className="mdi mdi-map-marker text-dark"
                      style={{
                        fontSize: "20px",
                        lineHeight: 1,
                        position: "relative",
                        top: 2,
                      }}
                    ></i>
                  </Col>
                  <Col xs="" className="pl-0">
                    <h5 className="m-0 font-weight-normal">
                      {suggestion.description}
                    </h5>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default LocationSuggestions;
